import { render, staticRenderFns } from "./Earrings.vue?vue&type=template&id=9886b740&"
import script from "./Earrings.vue?vue&type=script&lang=js&"
export * from "./Earrings.vue?vue&type=script&lang=js&"
import style0 from "./Earrings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports